import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, Input, Modal, Space, Spin, Table, Tooltip } from "antd";
import "./supply_slip.css";
import { IoAddCircleSharp, IoPrintSharp } from "react-icons/io5";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { FaPlusCircle } from "react-icons/fa";
import { TiDelete } from "react-icons/ti";
import withSupplySlipLogic from "./hoc_supply_slip";
import ModalDataWorkOrder from "./modal_data_work_order";
import ModalConfirmItemReady from "./modal_confirm_item_ready";
import ListItemWorkOrder from "./list_item_work_order";

const SupplySlip: React.FC<any> = ({
    columns,
    data,
    rowSelection,
    handleDelete,
    selectedRowKeys,
    form,
    isWorkOrderModalVisible,
    showWorkOrderModal,
    handleWorkOrderModalCancel,
    handleWorkOrderSelect,
    pagination,
    isConfirmModalVisible,
    itemsForConfirmModal,
    handleConfirmProceed,
    handleConfirmCancel,
    isListItemWorkOrderModalVisible,
    showListItemWorkOrderModal,
    handleListItemWorkOrderModalCancel,
    workOrderNoForListItemModal,
    existingItemCodesForListItemModal,
    warehouseForListItemModal,
    handleListItemWorkOrderAdd,
    handleNew,
    autosaveStatus,
    handleSubmit,
    handleVoid,
    isVoidButtonDisabled,
    isSubmitButtonDisabled,
    components,
    handlePrintClick,
    isPrinting,
    isPrintButtonDisabled,
    isReportModalOpen,
    handleReportModalCancel,
    isImportingWorkOrder,
    lockedFields,
    onFieldFocus,
    onFieldBlur,
    onFormValuesChange,
    getLockProps
}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const Newbtn = FaPlusCircle as React.ComponentType<any>;
    const Addbtn = IoAddCircleSharp as React.ComponentType<any>;
    const Deletebtn = TiDelete as React.ComponentType<any>;

    return (

        <div id="ir8c" style={transformStyle}>
            <div className="gjs-grid-row" id="iqrw">
                <div className="gjs-grid-column" id="itoi">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_supply_slip",
                                title: (
                                    <>
                                        <span>Data Supply Slip</span>
                                    </>
                                ),
                            },
                            {
                                title: "Supply Slip",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="if087">
                <div className="gjs-grid-column" id="ixl8l">
                    <Button
                        className="gr-button"
                        onClick={handleNew}
                        disabled={autosaveStatus === 'processing'}
                    >
                        <Newbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        New
                    </Button>
                    <Button
                        className="gr-button"
                        onClick={handleSubmit}
                        disabled={isSubmitButtonDisabled || autosaveStatus === 'processing'}
                    >
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Submit
                    </Button>
                    <Button className="gr-button" onClick={handleVoid} disabled={isVoidButtonDisabled || autosaveStatus === 'processing'}>
                        <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Void
                    </Button>
                    <Button className="gr-button" onClick={handlePrintClick} loading={isPrinting} disabled={isPrintButtonDisabled}>
                        <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'success' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>
            <Spin spinning={isImportingWorkOrder} tip="Memuat data Work Order...">
                <div className="gjs-grid-row" id="ia5dm">
                    <div className="gjs-grid-column" id="idbjs">
                        <Form
                            form={form}
                            layout="horizontal"
                            style={{ maxWidth: 440 }}
                            labelCol={{ style: { width: '150px', textAlign: "left" } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-purchase-request"
                            onValuesChange={onFormValuesChange}
                        >
                            <Form.Item
                                label="Status"
                                name='status'
                                style={{
                                    marginBottom: "5px",
                                }}
                                {...getLockProps("status")}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Supply Slip No"
                                name='supply_slip_no'
                                style={{
                                    marginBottom: "5px",
                                }}
                                {...getLockProps("supply_slip_no")}
                            >
                                <Input
                                    placeholder=""
                                    disabled={!!lockedFields?.["supply_slip_no"]}
                                    onFocus={() => onFieldFocus("supply_slip_no")}
                                    onBlur={() => onFieldBlur("supply_slip_no")}
                                    readOnly
                                />
                            </Form.Item>
                            <Form.Item
                                label="Supply Slip Date"
                                name='supply_slip_date'
                                style={{
                                    marginBottom: "5px",
                                }}
                                {...getLockProps("supply_slip_date")}
                            >
                                <Input
                                    placeholder=""
                                    disabled={!!lockedFields?.["supply_slip_date"]}
                                    onFocus={() => onFieldFocus("supply_slip_date")}
                                    onBlur={() => onFieldBlur("supply_slip_date")}
                                    readOnly
                                />
                            </Form.Item>
                            <Form.Item
                                label="Work Order No"
                                style={{ marginBottom: "5px" }}
                                {...getLockProps("work_order_no")}
                            >
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <Form.Item
                                        name="work_order_no"
                                        noStyle
                                        style={{ width: "100%" }}
                                        rules={[{ required: true, message: 'Work Order No. wajib diisi.' }]}
                                    >
                                        <Input
                                            style={{ width: "100%" }}
                                            readOnly
                                        />
                                    </Form.Item>
                                    <Button
                                        type="primary"
                                        id="modal_data_work_order"
                                        onClick={showWorkOrderModal}
                                        disabled={!!form.getFieldValue('work_order_no') || !!lockedFields?.["work_order_no"]} // ⚠️: disable tombol modal jika terkunci
                                        icon={
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                                <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                                <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                            </svg>}
                                    />
                                </div>
                            </Form.Item>
                            <Form.Item
                                label="Work Order Date"
                                name='work_order_date'
                                style={{
                                    marginBottom: "5px",
                                }}
                                {...getLockProps("work_order_date")}
                            >
                                <Input
                                    placeholder=""
                                    disabled={!!lockedFields?.["work_order_date"]}
                                    onFocus={() => onFieldFocus("work_order_date")}
                                    onBlur={() => onFieldBlur("work_order_date")}
                                    readOnly
                                />
                            </Form.Item>
                        </Form>
                    </div>
                    <div className="gjs-grid-column" id="i582n">
                        <Form
                            form={form}
                            layout="horizontal"
                            style={{ maxWidth: 400 }}
                            labelCol={{ style: { width: '150px', textAlign: "left" } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-purchase-request"
                            onValuesChange={onFormValuesChange}
                        >
                            <Form.Item
                                label="No. Polisi"
                                name='no_polisi'
                                style={{
                                    marginBottom: "5px",
                                }}
                                {...getLockProps("no_polisi")}
                            >
                                <Input
                                    placeholder=""
                                    disabled={!!lockedFields?.["no_polisi"]}
                                    onFocus={() => onFieldFocus("no_polisi")}
                                    onBlur={() => onFieldBlur("no_polisi")}
                                    readOnly
                                />
                            </Form.Item>
                            <Form.Item
                                label="Warehouse"
                                name='warehouse'
                                style={{
                                    marginBottom: "5px",
                                }}
                                {...getLockProps("warehouse")}
                            >
                                <Form.Item
                                    name="warehouse_name_display"
                                    noStyle
                                >
                                    <Input placeholder="" readOnly />
                                </Form.Item>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </Spin>
            <div className="gjs-grid-row" id="ixdow">
                <div className="gjs-grid-column" id="ixcno" style={{ maxWidth: 'max-content' }}>
                    <Button
                        className="gr-button"
                        onClick={showListItemWorkOrderModal}
                        disabled={!!lockedFields?.["add_item_modal"]}
                    >
                        <Addbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} id="list_item_work_order" />
                        Add Item
                    </Button>
                    <Button
                        className="gr-button"
                        onClick={handleDelete}
                        disabled={!selectedRowKeys || selectedRowKeys.length === 0 || selectedRowKeys.some((key: React.Key) => !!lockedFields?.[`row_${key}`] || !!lockedFields?.[`qty_supply_${key}`])}
                    >
                        <Deletebtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Delete
                    </Button>
                    <Table
                        bordered
                        scroll={{ x: 'max-content' }}
                        rowSelection={rowSelection}
                        components={components}
                        columns={columns}
                        dataSource={data}
                        pagination={pagination}
                        loading={isImportingWorkOrder}
                        rowClassName={(record: any) => (lockedFields?.[`qty_supply_${record.key}`] || lockedFields?.[`row_${record.key}`] ? "table-row-locked" : "")}
                    />
                </div>
            </div>
            <Modal
                title="Data Work Order"
                visible={isWorkOrderModalVisible}
                onCancel={handleWorkOrderModalCancel}
                footer={null}
                width={1000}
            >
                <ModalDataWorkOrder onRowSelect={handleWorkOrderSelect} isImporting={isImportingWorkOrder} />
            </Modal>
            <ModalConfirmItemReady
                visible={isConfirmModalVisible}
                insufficientItems={itemsForConfirmModal}
                onConfirm={handleConfirmProceed}
                onCancel={handleConfirmCancel}
            />
            <Modal
                title="List Item Work Order"
                visible={isListItemWorkOrderModalVisible}
                onCancel={handleListItemWorkOrderModalCancel}
                footer={null}
                width={1000}
            >
                <ListItemWorkOrder
                    workOrderNo={workOrderNoForListItemModal}
                    existingItemCodes={existingItemCodesForListItemModal}
                    warehouse={warehouseForListItemModal}
                    onAddItems={handleListItemWorkOrderAdd}
                />
            </Modal>
            <Modal
                title="Print Preview - Supply Slip"
                open={isReportModalOpen}
                onCancel={handleReportModalCancel}
                footer={null}
                width={1100}
                destroyOnClose
            >
                <div id="sti-viewer-container" style={{ width: '100%', minHeight: '75vh' }} />
            </Modal>
        </div>
    );
};

export default withSupplySlipLogic(SupplySlip);